import { Controller } from "@hotwired/stimulus"
import EasyMDE from "easymde"

export default class extends Controller {
  connect() {
    this.loadCSS()
    this.editor = new EasyMDE({
      element: this.element,
      spellChecker: false,
      status: false,
      minHeight: "400px",
      toolbar: [
        "bold", "italic", "heading", "|",
        "quote", "unordered-list", "ordered-list", "|",
        "link", "image", "|",
        "preview", "side-by-side", "|",
        "guide"
      ]
    })
  }

  disconnect() {
    if (this.editor) {
      this.editor.toTextArea()
      this.editor = null
    }
  }

  loadCSS() {
    if (document.querySelector('link[href*="easymde"]')) return

    const link = document.createElement("link")
    link.rel = "stylesheet"
    link.href = "/easymde.min.css"
    document.head.appendChild(link)
  }
}
